export const POPUPS = {
  RULES: "POPUPS.RULES", // rules
  MPESA_DEPOSIT: "POPUPS.MPESA_DEPOSIT", // mpesaDeposit
  MPESA_WITHDRAW: "POPUPS.MPESA_WITHDRAW", // mpesaWithdraw
  DEPOSIT_PENDING: "POPUPS.DEPOSIT_PENDING", // depositPending
  CASH_IN: "POPUPS.CASH_IN", // cashin
  SIGN_UP: "POPUPS.SIGN_UP", // signup
  SIGN_IN: "POPUPS.SIGN_IN", // signin
  CASHOUT: "POPUPS.CASHOUT", // cashout
  DEPOSIT: "POPUPS.DEPOSIT", // deposit
  LOGIN_FORM: "POPUPS.LOGIN_FORM", // LoginForm
  FAIL_POPUP: "POPUPS.FAIL_POPUP", // failPopup
  BET_BUILDER: "POPUPS.BET_BUILDER", // betBuilder
  STAFF_LOGIN: "POPUPS.STAFF_LOGIN", // staffLogin
  ERROR_POPUP: "POPUPS.ERROR_POPUP", // errorPopup
  CASHOUT_TYPE: "POPUPS.CASHOUT_TYPE", // cashOutType
  VIDEO_STREAM: "POPUPS.VIDEO_STREAM", // videoStream
  LOCK_TERMINAL: "POPUPS.LOCK_TERMINAL", // lockTerminal
  CASHOUT_POPUP: "POPUPS.CASHOUT_POPUP", // CashoutPopup
  SUPERBET: "POPUPS.SUPERBET", // superbet
  SUCCESS_POPUP: "POPUPS.SUCCESS_POPUP", // successPopup
  TERMINAL_ERROR: "POPUPS.TERMINAL_ERROR", // terminal-error
  CASHOUT_BY_PIX: "POPUPS.CASHOUT_BY_PIX", // cashoutByPix
  DEPOSIT_BY_PIX: "POPUPS.DEPOSIT_BY_PIX", // depositByPix
  LOCK_AND_UNLOCK: "POPUPS.LOCK_AND_UNLOCK", // lockAndUnlock
  FORGOT_PASSWORD: "POPUPS.FORGOT_PASSWORD", // forgotPassword
  CASHOUT_METHODS: "POPUPS.CASHOUT_METHODS", // cashoutMethods
  SET_PIN_CODE: "POPUPS.SET_PIN_CODE", // SetPinCode
  STATISTICS_POPUP: "POPUPS.STATISTICS_POPUP", // statisticsPopup
  CASHOUT_BY_TICKET: "POPUPS.CASHOUT_BY_TICKET", // cashoutByTicket
  RESET_SUCCESS: "POPUPS.RESET_SUCCESS", // resetPinSuccess
  INACTIVE_TERMINAL: "POPUPS.INACTIVE_TERMINAl", // inactiveTerminal
  LOGIN_BY_PIN_CODE: "POPUPS.LOGIN_BY_PIN_CODE", // LoginByPinCode
  RESET_PIN_CODE: "POPUPS.RESET_PIN_CODE", // ResetPinCode
  ODDS_FORMAT_SELECT: "POPUPS.ODDS_FORMAT_SELECT", // oddsformatselect
  SHOW_PAYMENT_POPUP: "POPUPS.SHOW_PAYMENT_POPUP", // showPaymentPopup
  CONFIRMATION_MODAL: "POPUPS.CONFIRMATION_MODAL", // ConfirmationModal
  LOGOUT_CONFIRMATION: "POPUPS.LOGOUT_CONFIRMATION", // logoutConfirmation
  CASHOUT_BY_BANK_CARD: "POPUPS.CASHOUT_BY_BANK_CARD", // cashoutByBankCard
  ERROR_LOGGED_IN_RFID: "POPUPS.ERROR_LOGGED_IN_RFID", // errorLoggedInRFID
  CONFIRM_TICKET_CLOSE: "POPUPS.CONFIRM_TICKET_CLOSE", // confirmTicketClose
  TERMS_AND_CONDITIONS: "POPUPS.TERMS_AND_CONDITIONS", // termsAndConditions
  CHANGE_PASSWORD_FORM: "POPUPS.CHANGE_PASSWORD_FORM", // ChangePasswordForm
  REGISTRATION_SUCCESS: "POPUPS.REGISTRATION_SUCCESS", // registrationSuccess
  LOYAL_CARD_INPUT_POPUP: "POPUPS.LOYAL_CARD_INPUT_POPUP", // loyalCardInputPopup
  TERMINAL_LOCK_REMINDER: "POPUPS.TERMINAL_LOCK_REMINDER", // terminalLockReminder
  MULTIPLE_TICKETS_POPUP: "POPUPS.MULTIPLE_TICKETS_POPUP", // multipleTicketsPopup
  TICKET_DETAILS_POPUP: "POPUPS.TICKET_DETAILS_POPUP",
  CHECK_TICKET_POPUP: "POPUPS.CHECK_TICKET_POPUP",
  REGISTER_BY_CNP_POPUP: " REGISTER_BY_CNP_POPUP",
  RFID_CHECK_POPUP: "RFID_CHECK_POPUP",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  WITHDRAWAL: "WITHDRAWAL",
  WITHDRAWAL_CONFIRM_POPUP: "WITHDRAWAL_CONFIRM_POPUP",
  WIN_IDENTIFICATION: "POPUPS.WIN_IDENTIFICATION",
  CNP_VERIFICATION: "POPUPS.CNP_VERIFICATION",
  CHOOSE_DEPOSIT_METHOD: "POPUPS.CHOOSE_DEPOSIT_METHOD",
  PRINT_BOOKING_TICKET: "POPUPS.PRINT_BOOKING_TICKET",
  PASSPORT_VERIFICATION: 'PASSPORT_VERIFICATION',
  PASSPORT_VERIFICATION_LOADING: 'PASSPORT_VERIFICATION_LOADING',
  PASSPORT_VERIFICATION_SUCCESS: 'PASSPORT_VERIFICATION_SUCCESS',
  PASSPORT_VERIFICATION_LOGOUT: 'PASSPORT_VERIFICATION_LOGOUT',
  PASSPORT_VERIFICATION_INACTIVE: 'PASSPORT_VERIFICATION_INACTIVE',
  PROFIT_BOOST_WHEEL: 'POPUPS.PROFIT_BOOST_WHEEL',
  PROFIT_BOOST_INFO: 'POPUPS.PROFIT_BOOST_INFO',
  PROFIT_BOOST: 'POPUPS.PROFIT_BOOST',
  REQUEST_PAYOUT: 'POPUPS.REQUEST_PAYOUT',
  IFRAME_POPUP: 'IFRAME_POPUP',
  EMBED_POPUP: 'EMBED_POPUP',
  VERIFICATION: 'VERIFICATION',
  INFO: 'INFO_POPUP',
  VERIFICATION_LOGOUT: 'VERIFICIATION_LOGOUT',
  CASHOUT_BY_OCTO: 'POPUPS.CASHOUT_BY_OCTO',
  NON_CASH_INACTIVE_POPUP: 'NON_CASH_INACTIVE_POPUP',
  TERMINAL_USAGE_CONFIRMATION_POPUP: 'POPUPS.TERMINAL_USAGE_CONFIRMATION_POPUP',
  SUCCESS_POPUP_WITH_BENEFITS: 'SUCCESS_POPUP_WITH_BENEFITS',
  PROCESS_POPUP: 'PROCESS_POPUP',
  CLIENT_DEPOSIT_POPUP: 'CLIENT_DEPOSIT_POPUP',
  CLIENT_DEPOSIT_FAIL_POPUP: 'CLIENT_DEPOSIT_FAIL_POPUP',
  TRANSFER_TO_USER: 'TRANSFER_TO_USER',
  JACKPOT_LIST_POPUP: 'JACKPOT_LIST_POPUP',
  DIGITAL_CASHOUT: 'POPUPS.DIGITAL_CASHOUT',
  REGISTRATION_FORM: 'POPUPS.REGISTRATION_FORM',
};
